// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2lJKx","errors":"Errors_errors__2t2hA"};